import { createGlobalStyle } from 'styled-components';
import Intents from '@ux/intents';

const {
  ux: {
    box: { density },
  },
} = new Intents();

const CardContainerGlobalStyle = createGlobalStyle`
  /* stylelint-disable-next-line selector-disallowed-list -- refactor with styled-components or UxCore components */
  .card.ux-card {
    padding: calc(${density} * 12) calc(${density} * 14);
  }

  /* stylelint-disable-next-line selector-disallowed-list -- refactor with styled-components or UxCore components */
  .card-block.idp {
    /* stylelint-disable-next-line declaration-no-important -- next who will be here, remove !important */
    padding: 0 !important;
  }
  
  @media (width <= 767px) {
    /* stylelint-disable-next-line selector-disallowed-list -- refactor with styled-components or UxCore components */
    .card.ux-card {
      padding: calc(${density} * 4) calc(${density} * 6);
    }
  }
`;

export default CardContainerGlobalStyle;
